import Api from '@/services/Api'

export default {

  host() {
    return "https://acs.accelery.de"
  },
  get () {
    return Api().get('apps')
  },
  getApp (id) {
    return Api().get('apps/'+ id)
  },
  create (app) {
    return Api().post('apps', app)
  },
  update (id, payload) {
    return Api().put('apps/' + id, payload)
  },
  delete(id) {
    return Api().delete('apps/' + id)
  } 
}
